const SESSION_KEY = "post_auth_cds_redirect";

export const CDS_POST_ONBOARDING_PATH =
  "/companySettings?section=identity&from=onboarding";

export function readIsFirst(
  data: { isFirst?: unknown; IsFirst?: unknown } | undefined
): boolean {
  const value = data?.isFirst ?? data?.IsFirst;
  return (
    value === true ||
    value === 1 ||
    value === "1" ||
    value === "true" ||
    value === "True"
  );
}

export function clearPostAuthRedirect(): void {
  sessionStorage.removeItem(SESSION_KEY);
}

/** Remember isFirst across 2FA step 1 → step 2 (no token yet). */
export function stashIsFirstRedirect(isFirst: boolean): void {
  if (isFirst) {
    sessionStorage.setItem(SESSION_KEY, CDS_POST_ONBOARDING_PATH);
  } else {
    clearPostAuthRedirect();
  }
}

export function peekPostAuthRedirect(): string | null {
  return sessionStorage.getItem(SESSION_KEY);
}

/** Direct login (token in response) — trust isFirst only, ignore stale stash. */
export function resolvePostAuthPath(isFirst: boolean, roleId?: number): string {
  if (isFirst) {
    sessionStorage.setItem(SESSION_KEY, CDS_POST_ONBOARDING_PATH);
    return CDS_POST_ONBOARDING_PATH;
  }
  clearPostAuthRedirect();
  if (roleId === -1) return "/";
  return roleId === 0 ? "/" : "/users";
}

/** After SMS 2FA — may use stash from step 1 when step 2 omits isFirst. */
export function resolvePostAuthPathAfter2FA(
  isFirst: boolean,
  roleId?: number
): string {
  if (isFirst || peekPostAuthRedirect()) {
    return CDS_POST_ONBOARDING_PATH;
  }
  clearPostAuthRedirect();
  if (roleId === -1) return "/";
  return roleId === 0 ? "/" : "/users";
}
